<template>
  <div @mouseenter="BLOCK_SCROLL_GLOBAL(true)"
       @click="blockSlider"
       @mouseleave="BLOCK_SCROLL_GLOBAL(false)"
      :class="['cards-slider-container', {'is-active-row' : isActiveRow } ]">
    <slot name="another-content"/>
    <div :class="[className, 'card-wrapper', {'is-not-active': idActiveCard !== item.id && isActivePadding},
                       {'is-active-low-gradient': idActiveCard > item.id },
                       {'is-active-opacity': idActiveCard > (item.id + 1) }]"
         @wheel="onWheel"
         @touchstart="onTouchStart"
         @touchend="onTouchEnd"
         @click="changeCard(item.id)"
         v-for="item in cardsInfo"
         :key="item.id"
         :style="{
                          transform: `translateX(${(getLeftTransform(item.id))})`
                       }">
      <slot name="card" :item="item"/>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";
import {mapActions} from "vuex";

export default {
  name: "SliderBanner",
  props: {
    isActiveStaticLastSlide: {
      type: Boolean,
      default: false
    },
    isChangeOut: {
      type: Boolean,
      default: false
    },
    idOut: {
      type: [Number, Boolean],
      default: false
    },
    cardsInfo: {
      type: Array,
      required: true
    },
    isActiveRow: {
      type: Boolean,
      default: false
    },
    isActivePadding: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: 'card-wrapper'
    }
  },
  data() {
    return {
      startX: 0,
      idActiveCard: 0,
      widthCard: 420
    }
  },
  mounted() {
    this.checkSize(2000);
    addEventListener('resize', this.checkSize)
  },
  watch: {
    idOut() {
     if(this.$isMobile && this.isChangeOut) {
       this.idActiveCard = this.idOut
     }
    }
  },
  unmounted() {
    removeEventListener('resize', this.checkSize)
  },
  methods: {
    ...mapActions(['BLOCK_SCROLL_GLOBAL']),
    blockSlider() {
      if(this.$isMobile) {
        this.BLOCK_SCROLL_GLOBAL(false)
      }
    },
    checkSize(time) {
      setTimeout(() => {
        let width = document.querySelector(`.${this.className}`)?.clientWidth;
        this.widthCard = width || 420
      }, time)
    },
    getLeftTransform(id) {
      let leftTransformStatic = `-${ this.widthCard * this.idActiveCard }px`;
      this.checkSize(0);
      if(id === 0 && this.idActiveCard === 0) {
        return `${ this.widthCard * id }px`
      } else {
        if(this.$isMobile) {
          let lastElement = this.cardsInfo[this.cardsInfo.length - 1]?.id;
          let activeId = this.isActiveStaticLastSlide && lastElement === this.idActiveCard
              ? this.idActiveCard - 1
              : this.idActiveCard
          return this.idActiveCard === this.isActiveRow
                  ? `-${ (this.widthCard + 10) * activeId }px`
                  : this.isActivePadding
                    ? `-${ (this.widthCard + 32) * activeId }px`
                    : `-${ this.widthCard * activeId }px`
        }
        return leftTransformStatic
      }
    },
    changeCard(id) {
      this.idActiveCard = id
      this.$emit('changeId', this.idActiveCard)
    },
    changeIdAction(isAction) {
      if (isAction) {
        if(this.idActiveCard !== 0) {
          this.changeCard(this.idActiveCard - 1)
        }
      } else {
        if(this.idActiveCard < (this.cardsInfo.length - 1)) {
          this.changeCard(this.idActiveCard + 1)
        }
      }
    },
    onWheel: debounce(function (e)  {
      this.changeIdAction(e.deltaY < 0)
    }, 100),
    onTouchStart(e) {
      this.startX = e.touches[0].clientX;
    },
    onTouchEnd(e) {
      const endX = e.changedTouches[0].clientX;
      const diffX = endX - this.startX;

      if (Math.abs(diffX) > 50) {
        this.changeIdAction(diffX > 0)
      }
    },
  }
}
</script>

<style scoped lang="scss">

.cards-slider-container {
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: row;
  &.active-left-direction {
    .card-wrapper {
      justify-content: flex-start;
    }
  }
}
.is-not-active {
  opacity: .4;
  &:hover {
    opacity: .8;
  }
}

.card-wrapper {
  display: flex;
  justify-content: center;
  transition: all 1s ease;
}
.is-active-low-gradient {
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 50%);
  mask-image: linear-gradient(to right, transparent 0%, black 50%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}
.is-active-opacity {
  opacity: 0;
}


@media (max-width: 3840px) {
    .cards-slider-container {
      right: -70%;
      bottom: 180px;
    }
    .is-not-active {
      padding: 30px 40px;
    }

}

@media (max-width: 3024px){

    .cards-slider-container {
      right: -95%;
      bottom: 180px;
    }
    .is-not-active {
      padding: 15px 20px;
    }
}

@media (max-width: 2560px) {
    .cards-slider-container {
      right: -85%;
    }
}

@media (max-width: 2240px) {
    .cards-slider-container {
      right: -75%;
    }
}


@media (max-width: 1920px) {
    .cards-slider-container {
      right: -75%;
      bottom: 169px;
    }
    .is-not-active {
      padding: 17px 20px;
    }
}
@media (max-width: 1600px) {
    .cards-slider-container {
      right: -80%;
      bottom: 136px;
    }
    .is-not-active {
      padding: 10px 20px;
    }
}
@media (max-height: 800px) {
    .cards-slider-container {
      bottom: 127px;
    }
}

@media (max-width: 1400px) and (min-height: 801px) {
    .cards-slider-container {
      bottom: 136px;
    }
    .is-not-active {
      padding: 10px 20px;
    }
}

@media (max-width: 1133px) {
    .cards-slider-container {
      right: -75%;
      bottom: 127px;
    }
}
@media (max-width: 769px) {
  .cards-slider-container {
    position: relative;
    right: auto;
    bottom: auto;
    &.is-active-row {
      column-gap: 10px;
    }
  }
  .is-not-active {
    padding: 10px 16px;
  }
  .is-active-low-gradient {
    -webkit-mask-image: none;
    mask-image: none;
    opacity: .4;
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3841px) {
    .cards-slider-container {
      right: -85%;
      bottom: 254px;
    }
    .is-not-active {
      padding: 30px 40px;
    }
}
</style>